import styles from "./HistoryItem.module.css";

export interface HistoryData {
    id: string;
    title: string;
    timestamp: number;
    patient_id?: string;
    total_tokens?: number;
    estimated_cost?: number;
    query_count?: number;
    total_backend_ms?: number;
}

interface HistoryItemProps {
    item: HistoryData;
    onSelect: (id: string) => void;
}

export function HistoryItem({ item, onSelect }: HistoryItemProps) {
    const costLabel =
        item.estimated_cost != null && item.estimated_cost > 0
            ? `~$${item.estimated_cost < 0.01 ? item.estimated_cost.toFixed(4) : item.estimated_cost.toFixed(2)}`
            : null;
    const tokensLabel = item.total_tokens ? `${(item.total_tokens / 1000).toFixed(1)}k tokens` : null;
    const queriesLabel = item.query_count ? `${item.query_count}q` : null;
    const timeLabel = item.total_backend_ms ? `${(item.total_backend_ms / 1000).toFixed(1)}s` : null;
    const metricsLine = [queriesLabel, timeLabel, tokensLabel, costLabel].filter(Boolean).join(" · ");

    return (
        <div className={styles.historyItem}>
            <button onClick={() => onSelect(item.id)} className={styles.historyItemButton}>
                <div className={styles.historyItemTitle}>{item.title}</div>
                {item.patient_id && <div className={styles.historyItemPatientId}>ID: {item.patient_id}</div>}
                {metricsLine && <div className={styles.historyItemMetrics}>{metricsLine}</div>}
            </button>
        </div>
    );
}
